export default "__VITE_ASSET__DVzPvsq7__"